<template>
  <div>
    <a-card>
      <div class="step-form">
        <a-steps :current="current" size="small">
          <a-step v-for="item in steps" :key="item.title" :title="item.title" />
        </a-steps>
        <div v-if="current === steps.length - 1" class="create-result">
          <a-result status="success" title="流程创建成功">
            <template #extra>
              <a-button v-if="templateLevel < 2" type="primary" @click="onCreateRelease"> 创建发布评审 </a-button>
              <a-button @click="onDetail"> 查看流程详情 </a-button>
              <a-button @click="onBack"> 返回流程列表 </a-button>
            </template>
          </a-result>
        </div>
        <div v-else-if="current === 0" class="steps-content">
          <a-form-model ref="baseForm" :model="form" :rules="rules">
            <a-form-model-item label="流程标题" prop="title">
              <a-input v-model="form.title" />
            </a-form-model-item>
            <a-form-model-item label="流程模板" prop="template_id">
              <workflow-template-from v-model="form.template_id" @onFocus="onFocus" />
            </a-form-model-item>
            <a-form-model-item v-if="templateLevel && templateLevel !== 1" label="关联流程" prop="relation_workflow">
              <a-list v-if="relationWorkflowData.length > 0" size="small" bordered :data-source="relationWorkflowData">
                <a-list-item slot="renderItem" slot-scope="item">{{ item.title }}</a-list-item>
              </a-list>
              <a-button icon="search" type="dashed" style="width: 100%" @click="relationVisible = true">选择流程</a-button>
            </a-form-model-item>
            <a-form-model-item v-show="false" label="备注信息">
              <a-input v-model="form.description" type="textarea" :auto-size="{ minRows: 3 }" />
            </a-form-model-item>
          </a-form-model>
        </div>
        <div v-else-if="current === 1" class="steps-content">
          <a-form-model ref="usersForm" :model="usersForm">
            <a-form-model-item v-if="Object.keys(templateOperationRoles).includes('DEV')" label="参与团队" prop="teams" :rules="{ required: true, message: `参与团队不能为空` }">
              <a-checkbox-group v-model="usersForm.teams" style="width: 100%">
                <a-row>
                  <a-col v-for="item in teamData" :key="item.id" :span="6">
                    <a-checkbox :value="item.id">{{ item.name }}</a-checkbox>
                  </a-col>
                </a-row>
              </a-checkbox-group>
            </a-form-model-item>
            <a-form-model-item v-for="(required, role) in templateOperationRoles" :key="role" :label="operationRoles[role].label" :prop="role" :rules="{ required: required, message: `${operationRoles[role].label}不能为空` }">
              <member-select v-if="role === 'DEV'" v-model="usersForm[role]" :team-ids="usersForm.teams" :placeholder="`请选择${operationRoles[role].label}`" />
              <user-select v-else-if="['PM', 'OM', 'TD'].includes(role)" v-model="usersForm[role]" :project-id="projectId" :placeholder="`请选择${operationRoles[role].label}`" />
              <user-select v-else-if="['OPS'].includes(role)" v-model="usersForm[role]" :role="role" :project-id="projectId" :placeholder="`请选择${operationRoles[role].label}`" />
              <user-select v-else v-model="usersForm[role]" :role="role" :project-id="projectId" :placeholder="`请选择${operationRoles[role].label}`" />
            </a-form-model-item>
          </a-form-model>
        </div>
        <div v-else-if="current === 2" class="steps-content">
          <a-descriptions size="small" title="基础信息" :column="2">
            <a-descriptions-item label="流程标题" :span="2"> {{ form.title }} </a-descriptions-item>
            <a-descriptions-item label="流程模板" :span="2"> {{ templateName }} </a-descriptions-item>
            <a-descriptions-item v-if="relationWorkflowData.length > 0" label="关联流程" :span="2" />
          </a-descriptions>
          <div v-if="relationWorkflowData.length > 0">
            <a-list size="small" bordered :data-source="relationWorkflowData">
              <a-list-item slot="renderItem" slot-scope="item">{{ item.title }}</a-list-item>
            </a-list>
            <a-alert style="margin: 16px 0" class="alert-info" message="流程关联后将不可修改，请确认关联的流程是否正确" type="warning" show-icon />
          </div>
          <a-descriptions size="small" layout="vertical">
            <a-descriptions-item v-if="checkServices.length > 0" :span="3" label="相关服务">
              <check-workflow-service :data-source="checkServices" />
            </a-descriptions-item>
            <a-descriptions-item :span="3" label="备注信息">
              <span style="white-space: pre-wrap"> {{ form.description }} </span>
            </a-descriptions-item>
          </a-descriptions>
          <a-divider />
          <a-descriptions size="small" title="参与人员" :column="1">
            <a-descriptions-item v-for="(_, role) in templateOperationRoles" :key="role" :label="operationRoles[role].label">
              <user-profiles :value="usersForm[role]" avatar />
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <div class="steps-action">
          <a-button v-if="current > 0 && current < steps.length - 1" v-tc="{ name: '上一步' }" @click="onPrevious"> 上一步 </a-button>
          <a-button v-if="current < steps.length - 2" v-tc="{ name: '下一步' }" type="primary" style="margin-left: 8px" @click="onNext"> 下一步 </a-button>
          <a-button v-if="current === steps.length - 2" v-tc="{ name: '确认' }" type="primary" style="margin-left: 8px" :loading="loading" @click="onSubmit"> 确认 </a-button>
        </div>
      </div>
    </a-card>
    <workflow-relation-from :is-show="relationVisible" :data-source="workflowData" :level="templateLevel" @close="close" />
  </div>
</template>
<script>
import { teamList } from '@/api/system/team';
import { getPersonalInfo } from '@/api/system/auth';
import { workflowOperationRoles } from '@/utils/dictionary';
import { workflowAdd, workflowList, workflowMergeInfo, fastCreateInfo } from '@/api/project/workflow';

import UserSelect from '@/pages/project/components/UserSelect';
import MemberSelect from '@/pages/project/components/MemberSelect';
import WorkflowTemplateFrom from '@/pages/project/workflow/components/WorkflowTemplateFrom';
import WorkflowRelationFrom from '@/pages/project/workflow/components/WorkflowRelationFrom';
import CheckWorkflowService from '@/pages/project/workflow/components/CheckWorkflowService';

export default {
  components: {
    UserSelect,
    MemberSelect,
    WorkflowTemplateFrom,
    WorkflowRelationFrom,
    CheckWorkflowService
  },
  data() {
    return {
      loading: false,
      projectId: parseInt(this.$route.params.project_id) || null,
      form: {
        relation_workflow: [],
        title: ''
      },
      usersForm: {
        teams: []
      },
      qa_list: [],
      auto_use: 0,
      userItems: {},
      checkServices: [],
      current: 0,
      workflowId: 1,
      templateList: [],
      workflowTypes: {
        1: {
          label: '迭代迭代',
          value: 1
        },
        2: {
          label: '问题修复',
          value: 2
        }
      },
      steps: [
        {
          title: '填写流程基础信息'
        },
        {
          title: '填写流程参与人员'
        },
        {
          title: '确认流程信息'
        },
        {
          title: '创建完成'
        }
      ],
      templateLevel: null,
      templateName: null,
      workflowData: null,
      relationVisible: false,
      relationWorkflowData: [],
      templateOperationRoles: {},
      operationRoles: workflowOperationRoles,
      teamData: [],
      rules: {
        title: [{ required: true, message: '流程标题不能为空', trigger: 'blur' }],
        template_id: [{ required: true, message: '流程模板不能为空', trigger: 'blur' }],
        workflow_type: [{ required: true, message: '流程类型不能为空', trigger: 'blur' }],
        teams: [{ required: true, message: '参与团队不能为空', trigger: 'blur' }],
        relation_workflow: [{ required: true, message: '关联流程不能为空', trigger: 'blur' }]
      }
    };
  },
  watch: {
    templateLevel() {
      this.workflowData = [];
      this.getWorkflowList();
    }
  },
  created() {
    this.getTeamList();
    this.fastCreate();
  },
  methods: {
    onNext() {
      if (this.current === 0) {
        this.$refs.baseForm.validate(valid => {
          if (valid) {
            this.current += 1;
            if (this.form.relation_workflow.length > 0) {
              this.checkServices = [];
              workflowMergeInfo({ project_id: this.projectId, workflow_ids: this.form.relation_workflow }).then(res => {
                this.checkServices = res.data.check_service;
                const users = {};
                const teams = res.data.workflow_teams.map(team => {
                  return team.id;
                });
                res.data.workflow_users.forEach(item => {
                  if (Object.keys(this.templateOperationRoles).includes(item.role_code)) {
                    users[item.role_code] = [];
                    item.users.forEach(user => {
                      users[item.role_code].push(user.user_id);
                    });
                  }
                });
                this.usersForm = { teams: teams, ...users };
              });
            }
          }
        });
      } else {
        this.$refs.usersForm.validate(valid => {
          if (valid) {
            this.current += 1;
          }
        });
      }
    },
    onPrevious() {
      this.current -= 1;
    },
    // 查看工作流详情
    onDetail() {
      this.$router.push({
        name: 'page:project:workflow:detail',
        query: { workflowId: this.workflowId }
      });
    },
    onBack() {
      this.$router.push({ name: 'page:project:workflow:list' });
    },
    onSubmit() {
      this.loading = true;
      const workflowForm = {
        ...this.form,
        project_id: this.projectId,
        teams: this.usersForm.teams,
        workflow_users: []
      };
      Object.keys(this.usersForm).forEach(item => {
        if (item !== 'teams') {
          workflowForm.workflow_users.push({
            role_code: item,
            users: this.usersForm[item]
          });
        }
      });
      workflowAdd(workflowForm)
        .then(res => {
          this.loading = false;
          this.workflowId = res.data.workflow_id;
          this.current = this.steps.length - 1;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getPersonal() {
      getPersonalInfo().then(res => {
        if (res.data.auto_use === 1) {
          this.qa_list = res.data.qa_list;
          this.$set(this.usersForm, 'QA', this.qa_list);
        }
      });
    },
    getWorkflowList() {
      // 获取工作流列表
      this.loading = true;
      workflowList({ project_id: this.projectId, level: this.templateLevel })
        .then(res => {
          this.workflowData = res.data.items.map(item => {
            return {
              key: item.id.toString(),
              title: `${item.id} - ${item.title}`,
              description: item.title
            };
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onFocus(template) {
      this.templateOperationRoles = template.operation_roles;
      if (Object.keys(this.templateOperationRoles).includes('OPS')) {
        this.$set(this.usersForm, 'OPS', [2]);
      } else {
        delete this.usersForm['OPS'];
      }
      this.templateLevel = template.level;
      this.templateName = template.name;
      this.relationWorkflowData = [];
      this.getPersonal();
    },

    onCreateRelease() {
      this.$router.push({
        name: 'page:project:workflow:release:create',
        query: { workflowId: this.workflowId }
      });
    },

    // 获取团队列表
    getTeamList() {
      teamList({}).then(res => {
        this.teamData = res.data.items;
      });
    },

    // 提交或关闭关联流程模态框的回调方法
    close(relationWorkflow = []) {
      this.relationVisible = false;
      if (relationWorkflow.length > 0) {
        this.form.relation_workflow = relationWorkflow.map(item => {
          return parseInt(item);
        });
        this.relationWorkflowData = [];
        this.workflowData.forEach(item => {
          if (relationWorkflow.includes(item.key)) {
            this.relationWorkflowData.push(item);
          }
        });
      } else {
        this.form.relation_workflow = [];
        this.relationWorkflowData = [];
      }
      const relationWorkflowNames = this.relationWorkflowData.map(item => item.title.split(' - ')[1]);
      if (relationWorkflowNames && relationWorkflowNames.length > 0) {
        this.$confirm({
          title: '替换流程名称提醒',
          content: {
            tag: 'span',
            children: [
              {
                tag: 'span',
                text: '是否使用关联流程名替换该流程名称? ('
              },
              {
                tag: 'span',
                data: {
                  style: 'color: red'
                },
                text: '合并关联流程名并以"&"字符连接'
              },
              {
                tag: 'span',
                text: ')'
              }
            ]
          },
          onOk: () => {
            this.form.title = relationWorkflowNames.join('&');
          }
        });
      }
      this.$refs.baseForm.validateField(['relation_workflow']);
    },

    fastCreate() {
      const workflowId = parseInt(this.$route.query.workflowId) || null;
      if (workflowId !== null) {
        // 判断获取关联流程信息, 判断当前流程的是否可以快速创建,并获取下一阶段流程模板ID
        fastCreateInfo({ project_id: this.projectId, workflow_id: workflowId }).then(res => {
          this.templateLevel = res.data.template_level;
          this.form.relation_workflow = [workflowId];
          this.form.title = res.data.workflow_title;
          this.form.template_id = res.data.template_id;
          this.templateName = res.data.template_name;
          this.templateOperationRoles = res.data.template_roles;
          this.$set(this.relationWorkflowData, 0, {
            key: `${res.data.workflow_id}`,
            title: `${res.data.workflow_id} - ${res.data.workflow_title}`,
            description: res.data.workflow_title
          });
          this.current = 1;
          workflowMergeInfo({ project_id: this.projectId, workflow_ids: this.form.relation_workflow }).then(res => {
            this.checkServices = res.data.check_service;
            const users = {};
            const teams = res.data.workflow_teams.map(team => {
              return team.id;
            });
            res.data.workflow_users.forEach(item => {
              if (Object.keys(this.templateOperationRoles).includes(item.role_code)) {
                users[item.role_code] = [];
                item.users.forEach(user => {
                  users[item.role_code].push(user.user_id);
                });
              }
            });
            this.usersForm = {
              teams: teams,
              ...users
            };
          });
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.step-form {
  width: 960px;
  margin: 0 auto;
  margin-top: 30px;

  .steps-content {
    width: 720px;
    margin: 0 auto;
    margin-top: 30px;
  }

  .steps-action {
    text-align: center;
  }

  .create-result {
    margin-top: 30px;
  }
}

/deep/.ant-form-item {
  margin-bottom: 8px;

  .ant-form-item-label {
    line-height: 28px;
  }
}
</style>
